import { Component, Input, OnInit }  from '@angular/core';
import { FormGroup }                 from '@angular/forms';

import { IngInputBase }              from '../inputs/ing-input-base';

@Component({
  selector: 'ing-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() inputs: IngInputBase<any>[] = [];
  @Input() formName: string;
  @Input() groups: Array<{id: string, title: string, class: string, classContainer: string, order: number, inputs: IngInputBase<any>[]}>;

  payload: string;

  constructor() {
    this.groups  = [];
    this.payload = '';
  }

  ngOnInit() {
  }

  onSubmit() {
    this.payload = JSON.stringify(this.form.value);
  }

  registerOnChange($event) {
    console.log($event);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/dynamic-form.component.ts